export default __webpack_public_path__ + "static/media/edit-button.54ef884c.svg";